import { IVA_AIOBI } from './config';

const CURRENCY_FORMATTER = new Intl.NumberFormat('pt-PT', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const PERCENT_FORMATTER = new Intl.NumberFormat('pt-PT', {
  style: 'percent',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

const NUMBER_FORMATTER = new Intl.NumberFormat('pt-PT', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

// /\s/g em JS regex apanha SPACE, TAB, NBSP (U+00A0) e outros whitespace
// Unicode — suficiente para limpar valores formatados PT-PT do Excel.
const EURO_SIGN = /€/g;
const ANY_WHITESPACE = /\s/g;

/** Formato PT-PT canonico: "1 234,56" + simbolo euro. */
export function formatCurrency(value: number): string {
  return CURRENCY_FORMATTER.format(value);
}

/** "12,5 %" com 1 decimal. Input em fraccao (0.125 -> "12,5 %"). */
export function formatPercent(fraction: number): string {
  return PERCENT_FORMATTER.format(fraction);
}

/** Numero generico ("1 234,56" ou "65"). */
export function formatNumber(value: number): string {
  return NUMBER_FORMATTER.format(value);
}

/**
 * Parser tolerante de strings formatadas PT-PT.
 * Aceita "69,36", "1.234,56", "1 234,56", todos com ou sem simbolo euro.
 * Para numeros retorna-os inalterados.
 */
export function parseCurrency(value: string | number | null | undefined): number {
  if (value == null) return 0;
  if (typeof value === 'number') return value;
  const cleaned = value.replace(EURO_SIGN, '').replace(ANY_WHITESPACE, '').trim();
  if (!cleaned) return 0;
  // PT-PT: "." milhar (opcional), "," decimal.
  const normalised = cleaned.replace(/\./g, '').replace(',', '.');
  const n = Number(normalised);
  return Number.isFinite(n) ? n : 0;
}

/** ROUND HALF UP a 2 decimais (centimo). */
export function roundToCents(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

/** ROUND a 4 decimais (precisao do F = E * 1,22 conforme PROMPT). */
export function roundTo4(value: number): number {
  return Math.round((value + Number.EPSILON) * 10000) / 10000;
}

/** Aplica IVA AIOBI 22% sobre liquido. Devolve c/IVA com 4 decimais. */
export function applyIva(net: number): number {
  return roundTo4(net * (1 + IVA_AIOBI));
}

/** Diff em centimos absoluto entre dois valores. */
export function centsDiff(a: number, b: number): number {
  return Math.abs(roundToCents(a - b));
}

/** True se a diferenca < 0,005 EUR. */
export function matchesAtCent(a: number, b: number): boolean {
  return centsDiff(a, b) < 0.005;
}
